export default {
    apiGateway: {
        REGION: "us-east-1",
        URL: "https://s7eoyjznfd.execute-api.us-east-1.amazonaws.com/v1"
    },
    cognito: {
        REGION: "us-east-1",
        USER_POOL_ID: "us-east-1_IniB08xqq",
        APP_CLIENT_ID: "6bafvpf7vgnlva2o5rl9252qf2",
        IDENTITY_POOL_ID: "us-east-1:a20af995-aeb2-42a0-850a-1ab9a019457d"
    }
};